import { render, staticRenderFns } from "./boardIndex.vue?vue&type=template&id=1a57b27c&scoped=true"
import script from "./boardIndex.vue?vue&type=script&lang=js"
export * from "./boardIndex.vue?vue&type=script&lang=js"
import style0 from "./boardIndex.vue?vue&type=style&index=0&id=1a57b27c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a57b27c",
  null
  
)

export default component.exports